import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
import theme from '@bnnvara/themes/src/theme';
import { allowedTypes } from '.';

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  color: ${theme.bnnvara.colors.base.black};
  ${breakpoints.md} {
    position: absolute;
    height: 100%;
    padding: 16px 16px 24px 16px;
  }
`;

export const CardImageWrapper = styled.div``;

export const CardImage = styled.img`
  min-width: 112px;
  max-width: 112px;
  height: 96px;
  object-fit: cover;
  ${breakpoints.md} {
    max-width: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: auto;
    max-height: none;
    width: 100%;
  }
  ${breakpoints.lg} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    max-height: none;
    width: auto;
  }
`;

export const TopContent = styled.div`
  position: absolute;
  margin-left: -120px;
  margin-top: -8px;
  ${breakpoints.md} {
    position: relative;
    margin-left: 0px;
    margin-top: 0px;
    margin-right: 0px;
  }
`;

export const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  *:last-child {
    margin-top: auto;
  }
  ${breakpoints.md} {
    display: block;
    margin-top: auto;
    height: auto;
  }
`;

export const CardContainer = styled.a`
  display: flex;
  background: ${theme.bnnvara.colors.base.white};
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  img {
    transition: all 0.1s ease-in-out;
  }
  ${({ variant }) => {
    // Media
    // Tablet & UP
    if (variant === allowedTypes[1]) {
      return `
      ${breakpoints.md} {
          ${CardImageWrapper} {
            padding-bottom: 55.55555%;
            height: 0;
            overflow: hidden;
            img {
              height: auto
            };
          }
          height: 100%;
          min-height: 350px;
          position: relative;
          overflow: hidden;
          flex-direction: column;
          &:hover {
            img {
              transform: scale(1.056);
            }
          }
          ${CardImage} {
            position: relative;
            width: 100%;
          }
          ${CardContent} {
            position: relative;
            ${TopContent} {
              margin: 0;
            }
            ${BottomContent} {
              display: flex;
              flex-direction: column;
              margin-top: 0;
              height: 100%;
              >*:last-child {
                margin-top: auto;
              }
            }
          }
        }
        ${CardImage} {
          top: 0;
          transform: none;
          left: 0;
          right: 0;
        }
        ${CardContent} {
          color: ${theme.bnnvara.colors.base.black};
        }
      `;
    }
    // Article && Default
    // Tablet & UP
    return `
      ${breakpoints.md} {
        position: relative;
        overflow: hidden;
        padding-bottom: 329px;
        &:hover {
          img {
            transform: translate(-50%, -50%) scale(1.056);
          }
        }
        ${CardContent} {
            color: ${theme.bnnvara.colors.base.white};
            background: linear-gradient(to bottom,rgba(0,0,0,0),rgba(0,0,0,0.7));
          }
        }
      `;
  }};
`;
